import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-vo2-max-dialog',
  templateUrl: './vo2-max-dialog.component.html',
  styleUrls: ['./vo2-max-dialog.component.scss'],
})
export class Vo2MaxDialogComponent implements OnInit {
  public form!: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private dialogRef: MatDialogRef<Vo2MaxDialogComponent>) {}

  public initForm(): void {
    this.form = this.fb.group({
      vo2_max: new UntypedFormControl(),
      tolerance: new UntypedFormControl(),
    });
  }

  public ngOnInit(): void {
    this.initForm();
  }

  public save(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value);
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }
}
